<template>
    <div>
        <section class="tab">
            <ul class="nav nav-tabs justify-content-around">
                <li class="nav-item" v-for="tab in tabs" v-if="tab.id !== 0">
                    <a class="nav-link" :class="{ 'active': tab.id === tabIndex }" :href='`#tab-${tab.id}`'
                       data-toggle="tab" @click="switchTab(tab.id)">{{ characters[tab.type+'_type'] }}</a>
                </li>
            </ul>

            <div class="tab-content">
                <div id="tab-0" class="tab-pane active">
                    <div v-if="tabIndex === 0">
                        <div v-if="playlists.length === 0" class="product-empty">
                            <div>
                                <img class="image-empty" :src='`/image/icons/state_${getTypeByIndex(tabIndex)}_emp.png`' alt="empty">
                            </div>
                            <div class="message">{{ characters.not_exist_playlist }}</div>
                        </div>
                        <div v-else class="product-item screen-transition" v-for="playlist in playlists" @click="playlist_item_click(playlist.playlist_id)">
                            <div class="playlist-info">
                                <div class="playlist-title">{{ playlist.title }}</div>
                                <div class="playlist-count">{{ playlist.count }}{{ characters.number_of_music }}</div>
                            </div>
                            <div class="item-price-container">
                                <img src="/image/icons/next.png">
                            </div>
                        </div>
                        <div class="product-empty"><a class="button btn btn-dark" role="button" aria-pressed="true" @click="openModal()" style="color:#FFFFFF;">{{ characters.regist_playlist }}</a></div>
                    </div>
                    <div v-if="tabIndex !== 0">
                        <div v-if="empty_flag" class="product-empty">
                            <div>
                                <img class="image-empty" :src='`/image/icons/state_${getTypeByIndex(tabIndex)}_emp.png`' alt="empty">
                            </div>
                            <div class="message">{{ tabIndex != null ? characters['not_exist_'+getTypeByIndex(tabIndex)] : '' }}</div>
                            <div><a class="button btn btn-dark" role="button" aria-pressed="true" @click="jumpStore()" style="color:#FFFFFF;">{{ characters['search_'+getTypeByIndex(tabIndex)] }}</a></div>
                        </div>
                        <div v-else class="product-item screen-transition" v-for="item in items" @click="player_item_click(item.item_id)">
                            <div class="item-image">
                                <img :src="'/item/image/'+item.item_id" class="profile-image" :alt="item.title">
                            </div>
                            <div class="item-info">
                                <div class="item-type" v-if="item_type_view_status == 1">{{ item.type_op }}&nbsp;{{ item.year}}</div>
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-content" v-if="item.album_flag===true">{{ characters.album }}({{ item.count }}{{ characters.number_of_music }})</div>
                                <div class="item-content" v-if="item.album_flag!==true">1{{ characters.number_of_music }}</div>
                            </div>
                            <div class="item-price-container">
                                <img src="/image/icons/next.png">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="tab-1" class="tab-pane">
                </div>
                <div id="tab-2" class="tab-pane">
                </div>
                <div id="tab-3" class="tab-pane">
                </div>
                <div id="tab-4" class="tab-pane">
                </div>
            </div>

            <div v-show="showContent">
                <transition name="modal">
                    <div class="modal-mask">
                        <div class="modal-wrapper" @click.self="closeModal()">
                            <div class="modal-container">
                                <div class="modal_ln">
                                    <p id="regist_playlist">{{ characters.regist_playlist }}</p>
                                    <input type="text" v-model="title" id="title" :placeholder="characters.input_playlist_name">
                                </div>
                                <div class="modal_btn">
                                    <button class="screen-transition" id="close" @click="closeModal()">{{ characters.cancel }}</button>
                                    <button class="screen-transition" id="make" @click="makePlaylist()">{{ characters.create }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "purchased-item",
        props: ['default_type', 'tab_list_bit', 'item_type_view_status', 'json_characters'],
        data: function () {
            return {
                tabIndex: null,
                count: 0,
                tabs: [],
                tab_origin: [
                    {id: 0, title: 'プレイリスト', type: 'playlist'},
                    {id: 1, title: '音楽', type: 'music'},
                    {id: 2, title: 'ビデオ', type: 'video'},
                    {id: 3, title: 'グッズ', type: 'goods'},
                    {id: 4, title: '写真・画像', type: 'photo'},
                    {id: 5, title: 'チケット', type: 'ticket'}
                ],
                ignore_tab_ids: [0, 3, 5],
                items: [],
                playlists: [],
                showContent: false,
                title: '',
                playlist_id: 0,
                empty_flag: false,
                characters: Object,
            }
        },
        mounted() {
            this.setTab();
            let tabIndex = this.getTabType(this.default_type)
            if(tabIndex) {
                localStorage.setItem('purchased-tabIndex', tabIndex);
            }
            if (localStorage.getItem('purchased-tabIndex') === null) {
                // tabIndex = 0;
                tabIndex = 1;
            } else {
                tabIndex = Number(localStorage.getItem('purchased-tabIndex'));
            }
            this.tabIndex = tabIndex;
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            switchTab: function (id) {
                this.tabIndex = id;
            },
            player_item_click: function (id) {
                location.href = `/purchased_item/${id}`;
            },
            playlist_item_click: function (id) {
                // console.log('playlist', id);
                location.href = `/playlist/detail/${id}`;
            },
            openModal: function() {
                this.showContent=true;
            },
            closeModal: function() {
                this.showContent=false;
            },
            makePlaylist: function() {
                if(this.title === '') {
                    alert(this.characters.input_playlist_name);
                } else {
                    axios.default
                        .post('/playlist/make/' + this.title)
                        .then(response => {
                            this.playlist_id = response.data;
                            location.href = `/playlist/detail/${this.playlist_id}`;
                            // location.href = `#`;
                        });
                    // location.href = `/playlist/detail/${this.playlist_id}`;
                    // location.href = `#`;
                }
            },
            jumpStore: function() {
                localStorage.setItem('store-tabIndex', this.tabIndex);
                location.href='/store';
            },
            checkIsDigitalContent: function(type) {
                const digital_content = ['Music', 'Video', 'Photo'];
                return digital_content.indexOf(type) > -1;
            },
            getTabType: function(type) {
                const tab = this.tabs.find(element => element.type === type);
                if(tab) {
                    // console.log(tab);
                    return tab.id;
                }
                return null;
            },
            setTab: function() {
                for(let i=0; i<this.tab_origin.length; i++) {
                    if(this.ignore_tab_ids.includes(i)) {
                        continue;
                    }
                    if(this.tab_list_bit & 2**i) {
                        this.tabs.push(this.tab_origin[i]);
                    }
                }
            },
            searchItem: function(type) {
                this.playlists = [];
                this.items = [];
                axios.default
                    .post('/purchased_list/' + type)
                    .then(response => {
                        if(type === 'playlist') {
                            this.playlists = response.data;
                        } else {
                            this.items = response.data;
                            this.empty_flag = (this.items.length===0)?true:false;
                        }
                    });
            },
            getTypeByIndex: function(index) {
                let type = '';
                switch (index) {
                    case 0:
                        type = 'playlist';
                        break;
                    case 1:
                        type = 'music';
                        break;
                    case 2:
                        type = 'video';
                        break;
                    case 3:
                        type = 'goods';
                        break;
                    case 4:
                        type = 'photo';
                        break;
                }
                return type;
            },
        },
        watch: {
            tabIndex: function (newIndex, oldIndex) {
                localStorage.setItem('purchased-tabIndex', newIndex);
                this.empty_flag=false;
                let type = this.getTypeByIndex(newIndex);
                this.searchItem(type);
            },
        }
    }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

 .modal-container {
  width: 70%;
  max-width: 300px;
  margin: 0px auto;
  padding: 5px 0px 0px 0px;
  background-color: #fff;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: .8em;
  -moz-border-radius: .8em;
  border-radius: .8em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

#modal {
    display: none;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 99;
    transform: translate(-50%, -50%);
    width: 70%;
    max-width: 400px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px;
    -webkit-border-radius: .8em;
    -moz-border-radius: .8em;
    border-radius: .8em;
    background-color: #fff;
}

#regist_playlist {
    text-align: center;
    margin: 20px 0 20px;
    font-size: 1rem;
}

.active {
    display: block !important;
}

.modal_ln {
    text-align: center;
    margin: 0 0 20px;
}

.modal_ln input[ type=text ] {
    width: 90%;
    font-size: 0.8rem;
}

.modal_btn {
	margin: 0;
    padding: 0;
	text-align: center;
    border-top: 1px solid gray;
}
.modal_btn button[ id=close ]{
    position: relative;
    display: inline-block;
    width: 45%;
    line-height: 3rem;
    color: dodgerblue;
    background: #FFF;
	-webkit-border-radius: 0 0 0 .8em;
	-moz-border-radius: 0 0 0 .8em;
	border-radius: 0 0 0 .8em;
	border: none;
	box-shadow: none;
    border-right: 1px solid gray;
    font-size: 0.8rem;
}
.modal_btn button[ id="make" ]{
    position: relative;
    display: inline-block;
    width: 45%;
    line-height: 3rem;
    color: dodgerblue;
    background: #FFF;
	-webkit-border-radius: 0 0 .8em 0;
	-moz-border-radius: 0 0 .8em 0;
	border-radius: 0 0 .8em 0;
	border: none;
	box-shadow: none;
    font-size: 0.8rem;
}
</style>
